var map = {
	"./add.svg": 47573,
	"./alipay.svg": 86738,
	"./arrdown.svg": 61201,
	"./arrleft.svg": 59466,
	"./arrup.svg": 59534,
	"./article-create.svg": 80939,
	"./article-ranking.svg": 29319,
	"./article.svg": 21586,
	"./audit.svg": 80889,
	"./bankcard.svg": 47224,
	"./bankcard1.svg": 13289,
	"./base-data.svg": 95924,
	"./bell.svg": 23271,
	"./binding.svg": 29695,
	"./blocked.svg": 99900,
	"./brandshop.svg": 50519,
	"./cart-down.svg": 57447,
	"./change-theme.svg": 94572,
	"./chart.svg": 90276,
	"./close.svg": 576,
	"./cloth.svg": 20376,
	"./cloth1.svg": 50761,
	"./colapse.svg": 59993,
	"./collapse.svg": 30097,
	"./copy.svg": 74267,
	"./dashboard.svg": 51520,
	"./data-upload.svg": 57978,
	"./delete.svg": 88133,
	"./diagnosis.svg": 90539,
	"./disabled.svg": 88740,
	"./disdroy.svg": 63678,
	"./down.svg": 93096,
	"./download.svg": 68516,
	"./download2.svg": 44190,
	"./edit.svg": 26440,
	"./empty.svg": 2407,
	"./error.svg": 22918,
	"./example.svg": 6958,
	"./exit-fullscreen.svg": 20718,
	"./expand.svg": 11356,
	"./expaned.svg": 98059,
	"./eye-open.svg": 84668,
	"./eye.svg": 91475,
	"./financial.svg": 49305,
	"./fullscreen.svg": 17231,
	"./getback.svg": 27889,
	"./gouxuan.svg": 22499,
	"./group.svg": 60093,
	"./guide.svg": 14428,
	"./hamburger-closed.svg": 60730,
	"./hamburger-opened.svg": 99945,
	"./histoires.svg": 26950,
	"./image.svg": 89043,
	"./info.svg": 17024,
	"./international.svg": 34416,
	"./introduce.svg": 11299,
	"./inventory.svg": 3272,
	"./language.svg": 50114,
	"./link.svg": 56140,
	"./loading.svg": 58056,
	"./medtruansfer.svg": 69014,
	"./myreg.svg": 80300,
	"./nested.svg": 83901,
	"./new.svg": 57334,
	"./next.svg": 59919,
	"./outlinepay.svg": 38268,
	"./outorder.svg": 65560,
	"./package.svg": 20340,
	"./password.svg": 37383,
	"./permission.svg": 73409,
	"./personnel-info.svg": 97053,
	"./personnel-manage.svg": 92,
	"./personnel.svg": 49668,
	"./prev.svg": 70595,
	"./refresh.svg": 53013,
	"./require.svg": 6449,
	"./reward.svg": 83849,
	"./role.svg": 78020,
	"./save.svg": 19923,
	"./search.svg": 69376,
	"./setting.svg": 24200,
	"./setting1.svg": 22041,
	"./shared.svg": 16003,
	"./shift.svg": 40152,
	"./size.svg": 3919,
	"./size1.svg": 61420,
	"./success.svg": 81029,
	"./table.svg": 13296,
	"./tel.svg": 70251,
	"./tree.svg": 21740,
	"./up.svg": 93371,
	"./upload.svg": 33527,
	"./user.svg": 77037,
	"./video.svg": 18069,
	"./viewer.svg": 29650,
	"./warn.svg": 90712,
	"./wechat.svg": 32294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;